// extracted by mini-css-extract-plugin
export default {"wrapper":"T7-z","play":"U7-z"};